import { TODAY } from '../../constants';
import { supabase } from '../../supabaseClient';
import { isoStr } from '../../utils/dates';

export function insertDealStatusChange(id, newStatus, session, today) {
  return supabase.from('affaire_activites').insert({
    affaire_id: id,
    nature: 'statut',
    type: newStatus,
    etat: 'fait',
    date: today,
    auteur_id: session.user.id,
  });
}

export function insertDealClosure(dealId, newStatus, session, today) {
  return supabase.from('affaire_activites').insert({
    affaire_id: dealId,
    nature: 'statut',
    type: newStatus,
    etat: 'fait',
    date: today,
    auteur_id: session.user.id,
  });
}

export function insertDealCreatedStatus(m, row, session) {
  return supabase.from('affaire_activites').insert({
    affaire_id: m.id,
    nature: 'statut',
    type: row.statut,
    etat: 'fait',
    date: isoStr(TODAY),
    auteur_id: session.user.id,
  });
}
